import React from "react";
import { Avatar } from "@mui/material";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";

import ThisTheme from "../../../themes/PORTTheme";

import EventNoteIcon from "@mui/icons-material/EventNote";
import NoteIcon from "@mui/icons-material/Note";
import DescriptionIcon from "@mui/icons-material/Description";
import CategoryIcon from "@mui/icons-material/Category";
import SourceIcon from "@mui/icons-material/Source";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";

import CheckIcon from "@mui/icons-material/Check";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
        height: 24,
        width: 24,
        borderRadius: "50%",
        backgroundColor: "#44b700",
        color: "#44b700",
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        border: `1px solid ${theme.palette.background.paper}`,
        padding: "0 4px",
    },
}));

export const avatarStyle = {
    backgroundColor: ThisTheme.palette.primary.main,
    color: "#FFF",
};

const PORTAvatar = React.forwardRef(function PORTAvatar(props, ref) {
    const { type, disabled, badge, ...rest } = props;

    let display = (
        <div {...rest} ref={ref}>
            <IconAvatar disabled={disabled} type={type} />
        </div>
    );

    switch (badge) {
        case "checked":
            display = (
                <StyledBadge
                    {...rest}
                    ref={ref}
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    badgeContent={
                        <CheckIcon
                            alt="Primary"
                            sx={{ fontSize: 16, color: "#FFFFFF" }}
                        />
                    }
                >
                    <IconAvatar disabled={disabled} type={type} />
                </StyledBadge>
            );

            break;

        case "attached":
            display = (
                <StyledBadge
                    {...rest}
                    ref={ref}
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    badgeContent={
                        <AttachFileIcon
                            alt="Associated"
                            sx={{ fontSize: 16, color: "#FFFFFF" }}
                        />
                    }
                >
                    <IconAvatar disabled={disabled} type={type} />
                </StyledBadge>
            );

            break;

        default:
            break;
    }

    return display;
});

const IconAvatar = ({ type = null, disabled = false }) => {
    const opacity = disabled ? 0.38 : 1;
    let icon = <SourceIcon />;

    switch (type) {
        case "pdp":
            icon = <FactCheckIcon />;
            break;

        case "developmentNeed":
            icon = <AutoGraphIcon />;
            break;

        case "activity":
            icon = <EventNoteIcon />;
            break;

        case "note":
            icon = <NoteIcon />;
            break;

        case "resource":
            icon = <DescriptionIcon />;
            break;

        case "qualification":
            icon = <HistoryEduIcon />;
            break;

        case "category":
            icon = <CategoryIcon />;
            break;

        default:
            break;
    }

    return (
        <Avatar
            aria-label="Avatar"
            style={{ ...avatarStyle, opacity: opacity }}
            sx={{ width: 52, height: 52, marginRight: "4px" }}
        >
            {icon}
        </Avatar>
    );
};

export default PORTAvatar;
